import { Grid } from '@material-ui/core';

import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface ReferencesProps {
  references: {
    merchantOrderReference1: string | null;
    merchantOrderReference2?: string | null;
  };
}

export const References = ({ references }: ReferencesProps) => {
  const { isMobile } = useScreen();
  if (!references) return <></>;
  return (
    <SubSectionWrapper title={'REFERENCES'}>
      <Grid container spacing={isMobile ? 0 : 4}>
        <Grid item xs={12} lg={6}>
          <ReadOnlyDataRow
            labelTextId={'MERCHANT_ORDER_REFERENCE_1'}
            value={references.merchantOrderReference1}
            tooltipTitle={<Text tId={'REFERENCE_1_TOOLTIP_TEXT'} />}
            underlined
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <ReadOnlyDataRow
            labelTextId={'MERCHANT_ORDER_REFERENCE_2'}
            value={references.merchantOrderReference2}
            tooltipTitle={<Text tId={'REFERENCE_2_TOOLTIP_TEXT'} />}
            underlined
          />
        </Grid>
      </Grid>
    </SubSectionWrapper>
  );
};
